export default __webpack_public_path__ + "static/pools-cb1f5b7ab911748cb12bdf7d65203f74.webp";